<template>
  <el-dialog
    :visible.sync="show"
    :modal="false"
    width="400px"
    top="30vh"
    custom-class="permission-dialog"
    :show-close="false"
    center
    @close="close"
  >
    <p class="desc">请选择您要发布的工单类型</p>
    <div slot="footer" class="dialog-footer">
      <button class="btn-create" v-for="(item,index) in createTypes" :key="index" @click="toCreateOrder(item)">{{item.jobName}}</button>
    </div>
  </el-dialog>
</template>
<script>
import { mapState,mapActions,mapGetters } from 'vuex';
export default {
  data(){
    return{
      
    }
  },
  props:{
    show:{
      type:Boolean,
      default:false,
    }
  },
  created() {
    this.loadPermission();
  },
  computed:{
    ...mapState({
      domainList:state=>state.domainList,
			userInfo:state=>state.userInfo,
    }),
    ...mapGetters({
      createTypes: "createTypes",
    }),
  },
  methods: {
    ...mapActions(['loadPermission']),
    //选择发单类型
    toCreateOrder(item){
      this.$emit('choose',item);
    },
    close(){
      this.$emit('close');
    }
  },
}
</script>
<style lang="scss">
.permission-dialog{
  width: 400px;
  background-color: #fff;
  border-radius: 10px;
  border: 4px solid rgba(51, 51, 51, 0.2);
  .el-dialog__header{
    display: none;
  }
  .desc{
    font-size: 18px;
    color: #333;
    line-height: 1.5;
    margin-top: 30px;
    text-align: center;
  }
  .btn-create{
    display: inline-block;
    width: 140px;
    height: 48px;
    border: 1px solid #f75959;
    border-radius: 50px;
    text-align: center;
    line-height: 46px;
    font-size: 16px;
    cursor: pointer;
    background: #fff;
    color: #f75959;
    &+.btn-create{
      margin-left: 20px;
    }
  }
}
</style>